//#region Libraries
//#endregion
//#region Styles
import { 
    Container,
    TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
import { CustomActionsCell, CustomCellDate, CustomCellReason } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const TableListItem = ({
    id, date,
    reason, deleteItem
}) => {
    const PROPS_CELL = {
        className: "small pair-row"
    };
    return (
        <Container>
            <TDef>
                <CustomCellDate {...PROPS_CELL}>
                    <h5 title={date}>{date}</h5>
                </CustomCellDate>
            </TDef>
            <TDef>
                <CustomCellReason {...PROPS_CELL}>
                    <h5 title={reason}>{reason}</h5>
                </CustomCellReason>
            </TDef>
            <TDef>
                <CustomActionsCell {...PROPS_CELL}>
                    <CustomButton 
                        variant="terciary"
                        color="dark"
                        icon={<TrashIcon/>}
                        onClick={() => deleteItem({ id, date })}/>
                </CustomActionsCell>
            </TDef>
        </Container>
    );
}

export default TableListItem;